"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationCreatedBy = exports.LocationReviewState = exports.LocationType = void 0;
var LocationType;
(function (LocationType) {
    LocationType["Airport"] = "airport";
    LocationType["BusStation"] = "bus_station";
    LocationType["BusStop"] = "bus_stop";
    LocationType["SubwayStation"] = "subway_station";
    LocationType["TrainStation"] = "train_station";
    LocationType["TransitStation"] = "transit_station";
    LocationType["Port"] = "port";
    LocationType["CityCenter"] = "city_center";
    LocationType["ContractSigningAddress"] = "contract_signing_address";
    LocationType["Other"] = "other";
})(LocationType = exports.LocationType || (exports.LocationType = {}));
var LocationReviewState;
(function (LocationReviewState) {
    LocationReviewState["Good"] = "good";
    LocationReviewState["Bad"] = "bad";
    LocationReviewState["None"] = "none";
})(LocationReviewState = exports.LocationReviewState || (exports.LocationReviewState = {}));
var LocationCreatedBy;
(function (LocationCreatedBy) {
    LocationCreatedBy["LowDetailsMapper"] = "low_details_mapper";
    LocationCreatedBy["Manual"] = "manual";
    LocationCreatedBy["LocationsCreatorMapper"] = "locations_creator_mapper";
    LocationCreatedBy["LocationsAndCitiesCreatorMapper"] = "locations_and_cities_creator_mapper";
})(LocationCreatedBy = exports.LocationCreatedBy || (exports.LocationCreatedBy = {}));
//# sourceMappingURL=locations.js.map